import './style.scss';

export function certifications_block() {
    const block = document.querySelector('.certifications_block');
    if (!block) return;
}
